import React from 'react';
import './HorseCard.css'; 
interface Horse {
  id: number;
  name: string;
  description: string;
  breed: string;
  photoUrl: string; // Placeholder for image source
}

interface HorseCardProps {
  horse: Horse;
}

const HorseCard: React.FC<HorseCardProps> = ({ horse }) => {
  return (
    <div className="horse-card">
      {/* In a real application, replace placeholder with actual image */}
      <img 
        src={horse.photoUrl || 'placeholder-horse.jpg'} 
        alt={`Photo de ${horse.name}`} 
        className="horse-card-image" 
      />
      <div className="horse-card-body">
        <h3>{horse.name}</h3>
        <p>{horse.description}</p>
      </div>
    </div>
  );
};

export default HorseCard;